const permissions = {
  LogEntry: {
    ADD: 1,
    CHANGE: 2,
    DELETE: 3,
    VIEW: 4,
  },
  Permission: {
    ADD: 5,
    CHANGE: 6,
    DELETE: 7,
    VIEW: 8,
  },
  Group: {
    ADD: 9,
    CHANGE: 10,
    DELETE: 11,
    VIEW: 12,
  },
  ContentType: {
    ADD: 13,
    CHANGE: 14,
    DELETE: 15,
    VIEW: 16,
  },
  Session: {
    ADD: 17,
    CHANGE: 18,
    DELETE: 19,
    VIEW: 20,
  },
  Token: {
    ADD: 21,
    CHANGE: 22,
    DELETE: 23,
    VIEW: 24,
  },
  TokenProxy: {
    ADD: 25,
    CHANGE: 26,
    DELETE: 27,
    VIEW: 28,
  },
  User: {
    ADD: 29,
    CHANGE: 30,
    DELETE: 31,
    VIEW: 32,
  },
  DestinationDelivery: {
    ADD: 33,
    CHANGE: 34,
    DELETE: 35,
    VIEW: 36,
    EXPORT: 203,
  },
  DestinationPackage: {
    ADD: 37,
    CHANGE: 38,
    DELETE: 39,
    VIEW: 40,
    EXPORT: 204,
  },
  OriginPackage: {
    ADD: 41,
    CHANGE: 42,
    DELETE: 43,
    VIEW: 44,
    EXPORT: 199,
  },
  Warehouse: {
    ADD: 45,
    CHANGE: 46,
    DELETE: 47,
    VIEW: 48,
  },
  OriginTransportation: {
    ADD: 49,
    CHANGE: 50,
    DELETE: 51,
    VIEW: 52,
  },
  OriginPackageTransportation: {
    ADD: 53,
    CHANGE: 54,
    DELETE: 55,
    VIEW: 56,
    EXPORT: 200,
    UPDATE_STATUS: 201,
    ISSUE_BILL: 202,
  },
  DestinationPackageDelivery: {
    ADD: 57,
    CHANGE: 58,
    DELETE: 59,
    VIEW: 60,
    EXPORT: 205,
  },
  Company: {
    ADD: 61,
    CHANGE: 62,
    DELETE: 63,
    VIEW: 64,
    EXPORT: 197,
  },
  Sale: {
    ADD: 65,
    CHANGE: 66,
    DELETE: 67,
    VIEW: 68,
  },
  Customer: {
    ADD: 69,
    CHANGE: 70,
    DELETE: 71,
    VIEW: 72,
    EXPORT: 198,
  },
  CustomerBill: {
    ADD: 73,
    CHANGE: 74,
    DELETE: 75,
    VIEW: 76,
    EXPORT: 207,
    PRINT: 208,
    PRINT_INVOICE: 209,
    CHANGE_STATUS: 213,
    EXPORT_REPORT_SUMMARY: 215,
  },
  CompanyBill: {
    ADD: 77,
    CHANGE: 78,
    DELETE: 79,
    VIEW: 80,
    EXPORT: 206,
    PRINT: 210,
    PRINT_INVOICE: 211,
    CHANGE_STATUS: 212,
    EXPORT_REPORT_SUMMARY: 214,
  },
  CompanyFormula: {
    ADD: 81,
    CHANGE: 82,
    DELETE: 83,
    VIEW: 84,
  },
  CompanyWeightFormula: {
    ADD: 85,
    CHANGE: 86,
    DELETE: 87,
    VIEW: 88,
  },
  CompanyVolumeFormula: {
    ADD: 89,
    CHANGE: 90,
    DELETE: 91,
    VIEW: 92,
  },
  CustomerFormula: {
    ADD: 93,
    CHANGE: 94,
    DELETE: 95,
    VIEW: 96,
  },
  CustomerWeightFormula: {
    ADD: 97,
    CHANGE: 98,
    DELETE: 99,
    VIEW: 100,
  },
  CustomerVolumeFormula: {
    ADD: 101,
    CHANGE: 102,
    DELETE: 103,
    VIEW: 104,
  },
  OriginPackageImage: {
    ADD: 105,
    CHANGE: 106,
    DELETE: 107,
    VIEW: 108,
  },
  SaleImage: {
    ADD: 109,
    CHANGE: 110,
    DELETE: 111,
    VIEW: 112,
  },
  CustomerImage: {
    ADD: 113,
    CHANGE: 114,
    DELETE: 115,
    VIEW: 116,
  },
  CompanyImage: {
    ADD: 117,
    CHANGE: 118,
    DELETE: 119,
    VIEW: 120,
  },
  OriginPackageService: {
    ADD: 121,
    CHANGE: 122,
    DELETE: 123,
    VIEW: 124,
  },
  CustomerRoute: {
    ADD: 125,
    CHANGE: 126,
    DELETE: 127,
    VIEW: 128,
  },
  CompanyRoute: {
    ADD: 129,
    CHANGE: 130,
    DELETE: 131,
    VIEW: 132,
  },
  DestinationPackageService: {
    ADD: 133,
    CHANGE: 134,
    DELETE: 135,
    VIEW: 136,
    EXPORT: 205,
  },
  DestinationPackageImage: {
    ADD: 137,
    CHANGE: 138,
    DELETE: 139,
    VIEW: 140,
  },
  CustomerBillItem: {
    ADD: 141,
    CHANGE: 142,
    DELETE: 143,
    VIEW: 144,
  },
  CompanyBillItem: {
    ADD: 145,
    CHANGE: 146,
    DELETE: 147,
    VIEW: 148,
    EXPORT: 206,
  },
  CustomerBillImage: {
    ADD: 149,
    CHANGE: 150,
    DELETE: 151,
    VIEW: 152,
  },
  CompanyBillImage: {
    ADD: 153,
    CHANGE: 154,
    DELETE: 155,
    VIEW: 156,
  },
  CustomerLine: {
    ADD: 157,
    CHANGE: 158,
    DELETE: 159,
    VIEW: 160,
  },
  CompanyLine: {
    ADD: 161,
    CHANGE: 162,
    DELETE: 163,
    VIEW: 164,
  },
  OriginPackageRate: {
    ADD: 165,
    CHANGE: 166,
    DELETE: 167,
    VIEW: 168,
  },
  ManagerCompany: {
    ADD: 169,
    CHANGE: 170,
    DELETE: 171,
    VIEW: 172,
  },
  Manager: {
    ADD: 173,
    CHANGE: 174,
    DELETE: 175,
    VIEW: 176,
  },
  CompanyBannerImage: {
    ADD: 177,
    CHANGE: 178,
    DELETE: 179,
    VIEW: 180,
  },
  CompanyNews: {
    ADD: 181,
    CHANGE: 182,
    DELETE: 183,
    VIEW: 184,
  },
  RequestSignup: {
    ADD: 185,
    CHANGE: 186,
    DELETE: 187,
    VIEW: 188,
  },
  CompanyPolicy: {
    ADD: 189,
    CHANGE: 190,
    DELETE: 191,
    VIEW: 192,
  },
  CompanySale: {
    ADD: 194,
    CHANGE: 195,
    DELETE: 196,
    VIEW: 193,
  },
  Dashboard: {
    VIEW: 220,
  },
};

export default permissions;
